<script setup>
import FormSection from "../../../Shared/Forms/FormSection";
import ActionMessage from "../../../Shared/Forms/ActionMessage";
import Button from "../../../Shared/Forms/Button";
import { useForm, usePage } from "@inertiajs/inertia-vue3";
import { computed } from "vue";

const props = defineProps(['address'])
const form = useForm({
  first_name: props.address.firstname,
  last_name: props.address.lastname,
  street: props.address.street,
  house_number: props.address.house_number,
  postal_code: props.address.postal_code,
  city: props.address.city,
  country: props.address.country,
  phone_number: props.address.phone_number,
})

function updateProfileInformation() {
  form.put(route('address.update', props.address.id), {
    errorBag: 'updateAddress',
    preserveScroll: true,
  });
}

const customer = computed(() => usePage().props.value.auth.customer)

</script>
<template>
  <FormSection @submitted="updateProfileInformation">
    <template #title>
      Profile Informatie
    </template>

    <template #description>
      Uw contactgegevens zodat wij weten wie u bent.
    </template>

    <template #form>

      <div class="col-span-6 sm:col-span-3">
        <label for="first-name" class="block text-sm font-medium text-gray-700"> Voornaam </label>
        <div class="mt-1">
          <input v-model="form.first_name" type="text" name="first-name" id="first-name" autocomplete="given-name" class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary sm:text-sm" :disabled="disabled" />
        </div>
        <div v-if="form.errors.first_name" v-text="form.errors.first_name" class="text-red-500 text-xs mt-1"></div>
      </div>

      <div class="col-span-6 sm:col-span-3">
        <label for="last-name" class="block text-sm font-medium text-gray-700"> Achternaam </label>
        <div class="mt-1">
          <input v-model="form.last_name" type="text" name="last-name" id="last-name" autocomplete="family-name" class="shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md" :disabled="disabled" />
        </div>
        <div v-if="form.errors.last_name" v-text="form.errors.last_name" class="text-red-500 text-xs mt-1"></div>
      </div>

      <div class="col-span-6 sm:col-span-4">
        <label for="phone_number" class="block text-sm font-medium text-gray-700">Telefoonnummer</label>
        <div class="mt-1">
          <input v-model="form.phone_number" type="tel" name="phone_number" id="phone_number" autocomplete="tel" class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary sm:text-sm" :disabled="disabled" />
          <div v-if="form.errors.phone_number" v-text="form.errors.phone_number" class="text-red-500 text-xs mt-1"></div>
        </div>
      </div>

      <div class="col-span-6 sm:col-span-4">
        <label for="address-line1" class="block text-sm font-medium text-gray-700"> Straatnaam </label>
        <div class="mt-1">
          <input v-model="form.street" type="text" name="address-line1" id="address-line1" autocomplete="address-line1" class="shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md" :disabled="disabled"/>
        </div>
        <div v-if="form.errors.street" v-text="form.errors.street" class="text-red-500 text-xs mt-1"></div>
      </div>

      <div class="sm:col-span-2">
        <label for="address-line2" class="block text-sm font-medium text-gray-700"> Huisnummer </label>
        <div class="mt-1">
          <input v-model="form.house_number" type="text" name="address-line2" id="address-line2" autocomplete="address-line2" class="shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md" :disabled="disabled"/>
        </div>
        <div v-if="form.errors.house_number" v-text="form.errors.house_number" class="text-red-500 text-xs mt-1"></div>
      </div>

      <div class="sm:col-span-2">
        <label for="postal-code" class="block text-sm font-medium text-gray-700"> Postcode </label>
        <div class="mt-1">
          <input v-model="form.postal_code" type="text" name="postal-code" id="postal-code" autocomplete="postal-code" class="shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md" :disabled="disabled" />
        </div>
        <div v-if="form.errors.postal_code" v-text="form.errors.postal_code" class="text-red-500 text-xs mt-1"></div>
      </div>

      <div class="sm:col-span-4">
        <label for="city" class="block text-sm font-medium text-gray-700"> Stad </label>
        <div class="mt-1">
          <input v-model="form.city" type="text" name="city" id="city" autocomplete="address-level2" class="shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md" :disabled="disabled" />
        </div>
        <div v-if="form.errors.city" v-text="form.errors.city" class="text-red-500 text-xs mt-1"></div>
      </div>

      <div class="sm:col-span-3">
        <label for="country" class="block text-sm font-medium text-gray-700"> Land </label>
        <div class="mt-1">
          <select v-model="form.country" id="country" name="country" autocomplete="country-name" class="shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md" :disabled="disabled">
            <option value="NL" selected>Nederland</option>
          </select>
        </div>
        <div v-if="form.errors.country" v-text="form.errors.country" class="text-red-500 text-xs mt-1"></div>
      </div>

    </template>

    <template #actions>
      <ActionMessage :on="form.recentlySuccessful" class="mr-3">
        {{ __('Opgeslagen.') }}
      </ActionMessage>

      <Button :class="{ 'opacity-25': form.processing }" :disabled="form.processing || disabled" >
        {{ __('Opslaan') }}
      </Button>
    </template>
  </FormSection>
</template>
